import { render, staticRenderFns } from "./m-product-gallery.vue?vue&type=template&id=1eed3519&scoped=true&"
import script from "./m-product-gallery.vue?vue&type=script&lang=js&"
export * from "./m-product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./m-product-gallery.vue?vue&type=style&index=0&id=1eed3519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eed3519",
  null
  
)

export default component.exports